import WordPicker from './WordPicker';
import MultipleChoise from './MultipleChoise';
import ActivityPicker from './ActivityPicker';
import ActivityOverview from './ActivityOverview';
import NetworkPicker from './NetworkPicker';
import NetworkActivityPicker from './NetworkActivityPicker';
import NetworkPersonPicker from './NetworkPersonPicker';
import Feelings from './Feelings';
import EndScreen from './EndScreen';

export default {
    WordPicker,
    MultipleChoise,
    ActivityPicker,
    ActivityOverview,
    NetworkPicker,
    NetworkActivityPicker,
    NetworkPersonPicker,
    Feelings,
    EndScreen,
};



// WEBPACK FOOTER //
// ./src/components/questions/index.js